import { resolveMapDeepLink } from '@map/components/app/deepLinks';
import ConfirmModal from '@map/components/layout/ConfirmModal';
import DeepLinks from '@shared/components/DeepLinks';
import { useFormatMessage } from '@shared/hooks/intl';
import { ReactNode, useCallback, useRef, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

const routePrefix = (window as any).base_url;

const RoutingProvider = ({ children }: { children: ReactNode }) => {
  const callbackRef = useRef<(ok: boolean) => void>();
  const [promptMessage, setPromptMessage] = useState('');
  const t = useFormatMessage();

  const handleConfirm = useCallback(() => {
    callbackRef.current?.(true);
    setPromptMessage('');
  }, []);
  const handleCancel = useCallback(() => {
    callbackRef.current?.(false);
    setPromptMessage('');
  }, []);

  return (
    <>
      <BrowserRouter
        basename={routePrefix}
        // TODO: do we need this?
        getUserConfirmation={(message, callback) => {
          setPromptMessage(message);
          callbackRef.current = callback;
        }}
      >
        {children}
        <DeepLinks resolve={resolveMapDeepLink} />
      </BrowserRouter>
      {promptMessage && (
        <ConfirmModal
          open
          variant="centered"
          text={promptMessage === 'default' ? t('common.leaver_warning') : promptMessage}
          confirmLabel={t('common.leaver_confirm')}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </>
  );
};

export default RoutingProvider;
